module.exports = __webpack_public_path__ + "img/20210904_114323.5a650bc0.jpg";